export const environment = {
  production: false
};



// WEBPACK FOOTER //
// /tmp/stackline-angular-loading-docs-4-fU6jD5/src/environments/environment.ts